import React from 'react'
import  "./home.css"

function Social() {
  return (
    <div className='home__social'>
        <a href="#" className='home__social-icon' target="_blank"></a>


        <a href="#" className='home__social-icon' target="_blank"></a>

    </div>
  )
}
export default Social
